import * as Sentry from "@sentry/nuxt";

Sentry.init({
  // If set up, you can use your runtime config here
  // dsn: useRuntimeConfig().public.sentry.dsn,
  dsn: "https://f85e0286dcc8520d766fb0333dcb468c@o4504802128101376.ingest.us.sentry.io/4508093601677312",
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  environment: useRuntimeConfig().public.appEnv,
  enabled: useRuntimeConfig().public.appEnv === "production" || useRuntimeConfig().public.appEnv === "staging",
  // Tracing
  // We recommend adjusting this value in production, or using a tracesSampler for finer control.
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/switchcase/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});